import { Spinner } from '@/components/ui/Spinner';
import { cn } from '@/lib/cn';

/**
 * A7 · EL ESTADO DE CARGA, uno solo.
 *
 * Había **siete alturas distintas** para lo mismo (`py-4`, `py-8`, `py-10`,
 * `py-12`, `py-16`, `p-8`, `p-10`). Cada pantalla saltaba distinto al cargar, y
 * el salto de la altura es lo que hace que la página "baile" cuando llegan los
 * datos.
 *
 * Dos tamaños y nada más:
 *  - `pantalla` — cuando carga la pantalla entera.
 *  - `bloque`   — cuando carga una tabla o una tarjeta adentro de la pantalla.
 *
 * ⚠️ Lleva `aria-live`: quien usa lector de pantalla necesita enterarse de que
 * algo está cargando, y un spinner mudo no le dice nada.
 */
export function Cargando({
  tamano = 'bloque',
  className,
}: {
  tamano?: 'pantalla' | 'bloque';
  className?: string;
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={cn('flex justify-center', tamano === 'pantalla' ? 'py-16' : 'py-10', className)}
    >
      <Spinner />
      <span className="sr-only">Cargando…</span>
    </div>
  );
}
